// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__296AY","requiredAsterisk":"Info_requiredAsterisk__1XfHP"};